module.exports = __webpack_public_path__ + "img/404.37353558.png";